import * as React from "react";


export default function AccountPage() {
    return <div>Account page</div>;
}
